import React from 'react';

export const WhatsAppButton = () => {
  const phone = '919844110041';
  const message = encodeURIComponent('Hi, I have checked your website and I want to know more about Ad Astra.');
  const url = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-[9990] w-14 h-14 rounded-full flex items-center justify-center shadow-lg transition-transform duration-300 hover:scale-110"
      style={{ backgroundColor: '#25D366' }}
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
        <path d="M16.004 3.2C8.95 3.2 3.21 8.93 3.207 15.983c-.001 2.252.588 4.45 1.707 6.39L3.2 28.8l6.614-1.735a12.74 12.74 0 006.18 1.575h.005c7.05 0 12.793-5.735 12.796-12.787.002-3.418-1.33-6.63-3.75-9.048A12.72 12.72 0 0016.004 3.2zm0 23.36h-.004a10.6 10.6 0 01-5.4-1.48l-.388-.23-4.02 1.054 1.073-3.918-.252-.4a10.56 10.56 0 01-1.62-5.6C5.396 10.14 10.17 5.37 16.009 5.37c2.83.001 5.49 1.104 7.49 3.108a10.52 10.52 0 013.098 7.5c-.003 5.835-4.776 10.582-10.593 10.582zm5.806-7.93c-.318-.159-1.882-.928-2.174-1.034-.292-.106-.505-.16-.717.159-.213.318-.823 1.034-1.01 1.247-.186.213-.372.239-.69.08-.318-.16-1.343-.495-2.558-1.578-.945-.843-1.584-1.884-1.77-2.202-.186-.318-.02-.49.14-.648.144-.143.318-.372.477-.558.16-.186.213-.32.318-.532.106-.213.053-.399-.027-.558-.08-.16-.717-1.73-.983-2.368-.258-.622-.522-.538-.717-.548-.186-.01-.399-.011-.611-.011a1.17 1.17 0 00-.85.399c-.291.318-1.116 1.09-1.116 2.66 0 1.57 1.142 3.086 1.301 3.3.16.212 2.248 3.433 5.45 4.813.76.329 1.355.525 1.817.672.764.243 1.46.209 2.008.127.613-.092 1.882-.77 2.148-1.513.265-.743.265-1.38.186-1.513-.08-.133-.292-.213-.611-.372z"/>
      </svg>
    </a>
  );
};
